module.exports = __webpack_public_path__ + "img/01宋雷.ad0cbf5f.jpg";